
interface ArchiveIconProps {
  size?: number;
  color?: string;
  title?: string;
}

export default function ArchiveIcon({ size = 24, color = 'currentColor', title }: ArchiveIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {title && <title>{title}</title>}
      {/* Lid */}
      <rect x="3" y="3" width="18" height="4" rx="1.5" />
      {/* Box */}
      <rect x="4.5" y="7" width="15" height="13" rx="2" />
      {/* Handle */}
      <rect x="9" y="13" width="6" height="2.25" rx="1.125" />
    </svg>
  );
}
